import React, { memo } from 'react';
import useFormattedPrice from '../../../../commons/hooks/useFormattedPrice';
import S from './style/Price';
import { PriceComponent, TotalDetails } from '../../../../../typings/transaction';

interface PriceProps {
  prices: {
    components: PriceComponent[];
    total: TotalDetails;
  };
}

const Price: React.FC<PriceProps> = function Price({ prices }) {
  const itemPrice = prices.components.find(
    (price: PriceComponent) => price.code === 'item-price',
  )?.value;
  const formattedPrice = useFormattedPrice(itemPrice);

  if (!itemPrice.amount) {
    return null;
  }

  return (
    <S.InfoPrice data-testid="overview-price" data-cy="overview-price">
      {formattedPrice}
    </S.InfoPrice>
  );
};

export default memo(Price);
